module.exports = __webpack_public_path__ + "img/icon-denuncia.fb3065ca.svg";